import { Typography, withTypographyContainer } from 'shared/ui/typography';
import { MarginBottom } from './styles';
import { SelectTag } from 'shared/ui/select/selectTag';
import { FC } from 'react';

interface OrderTagsFilterProps {
	tagsOptions: any;
	selectedTagsOptions: any;
	changeTags: any;
	label: string;
}

export const SelectTags: FC<OrderTagsFilterProps> = ({
	tagsOptions,
	selectedTagsOptions,
	changeTags,
	label = 'Теги бронирования',
}) => {
  const Label = withTypographyContainer(Typography);

	return (
		<MarginBottom>
			<div>
				<Label colorVariant={'main'} isBold={true}>
					{label}
				</Label>
				<SelectTag
					options={tagsOptions}
					value={selectedTagsOptions}
					onSelect={changeTags}
					placeholder="Выберите тэги"
				/>
			</div>
		</MarginBottom>
	);
};
